import { render, staticRenderFns } from "./remits.vue?vue&type=template&id=25413d0c&"
import script from "./remits.vue?vue&type=script&lang=js&"
export * from "./remits.vue?vue&type=script&lang=js&"
import style0 from "./remits.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports